document.addEventListener("DOMContentLoaded", function () {
  const accountBtn = document.getElementById("account-login-btn");
  const modal = document.getElementById("login-modal");

  const loginFormDiv = document.getElementById("login-form");
  const recoverPasswordForm = document.getElementById("recover-password");
  const signupForm = document.getElementById("signup-form");
  const loginModal = document.getElementById("login-modal");

  const forgotPasswordLink = document.getElementById("forgot-password-link");
  const createAccountLink = document.getElementById("create-account-link");
  const backToLogin1 = document.getElementById("back-to-login-1");
  const backToLogin2 = document.getElementById("back-to-login-2");
  const backBtn = document.getElementById("back-btn");

  const loginForm = document.getElementById("custom-login-form");
  const loginErrorDiv = document.getElementById("login-error");
  const loginButton = document.getElementById("login-btn");
  const emailInput = document.getElementById("customer_email");
  const passwordInput = document.getElementById("customer_password");

  const regForm = document.getElementById("custom_create_customer");
  const regButton = document.getElementById("register-btn");
  const regErrorDiv = document.getElementById("register-error");
  const regFirstNameInput = document.getElementById("first_name");
  const regLastNameInput = document.getElementById("last_name");
  const regEmailInput = document.getElementById("email");
  const regPasswordInput = document.getElementById("password");

  const recoverForm = document.getElementById("custom_reset_form");
  const recoverEmailInput = document.getElementById("recover-email");
  const recoverButton = document.getElementById("reset_password_btn");
  const recoverErrorDiv = document.getElementById("reset-password-error");
  
  if (accountBtn) {
    accountBtn.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default link action
      modal.style.display = "flex";
    });
  }

  function showForm(show, hide1, hide2) {
    show.classList.remove("hidden");
    hide1.classList.add("hidden");
    hide2.classList.add("hidden");
  }

  if (forgotPasswordLink) {
    forgotPasswordLink.addEventListener("click", function (event) {
      event.preventDefault();
      showForm(recoverPasswordForm, loginFormDiv, signupForm);
    });
  }

  if (createAccountLink) {
    createAccountLink.addEventListener("click", function (event) {
      event.preventDefault();
      showForm(signupForm, loginFormDiv, recoverPasswordForm);
    });
  }

  if (backToLogin1) {
    backToLogin1.addEventListener("click", function (event) {
      event.preventDefault();
      showForm(loginFormDiv, recoverPasswordForm, signupForm);
    });
  }

  if (backToLogin2) {
    backToLogin2.addEventListener("click", function (event) {
      event.preventDefault();
      showForm(loginFormDiv, recoverPasswordForm, signupForm);
    });
  }

  if (backBtn) {
    backBtn.addEventListener("click", function () {
      modal.style.display = "none";
      showForm(loginFormDiv, recoverPasswordForm, signupForm);
    });
  }

  // document.getElementById("back-to-login-recover").addEventListener("click", function (event) {
  //           event.preventDefault();
  //           document.getElementById("login-form").classList.remove("hidden");
  //           recoverForm.classList.add("hidden");
  //         });
  
  if(loginForm){
    // Disable login button by default
    loginButton.disabled = true;
  
    // Function to check if both fields are filled
    function validateForm() {
        if (emailInput.value.trim() !== "" && passwordInput.value.trim() !== "") {
            loginButton.disabled = false;
        } else {
            loginButton.disabled = true;
        }
    }
  
    // Listen for input changes on both fields
    emailInput.addEventListener("input", validateForm);
    passwordInput.addEventListener("input", validateForm);
  
  
    loginForm.addEventListener("submit", function (event) {
        event.preventDefault(); // Prevent form submission and page reload
  
        const formData = new FormData(loginForm);
  
        fetch('/account/login', {
            method: 'POST',
            body: formData,
            headers: {
                "X-Requested-With": "XMLHttpRequest" // Tells Shopify this is an AJAX request
            }
        })
        .then(response => response.text()) // Parse response as text (Shopify returns HTML)
        .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, "text/html");
  
            // Shopify's login error messages are usually in a div with class "form__message"
            const errorMessage = doc.querySelector(".errors-text");
  
            if (errorMessage) {
                // Show error inside the modal and prevent closing
                loginErrorDiv.innerHTML = errorMessage.innerHTML;
                loginErrorDiv.classList.remove("hidden");
  
                // Ensure the popup remains open
                if (modal) {
                    modal.style.display = "flex"; // Adjust as per your modal's display style
                }
            } else {
                // If no error, assume login was successful
                window.location.reload();
            }
        })
        .catch(error => {
            console.error("Login failed:", error);
            loginErrorDiv.innerHTML = "An error occurred. Please try again.";
            loginErrorDiv.classList.remove("hidden");
  
            // Ensure modal stays open
            if (modal) {
                modal.style.display = "flex";
            }
        });
    });
  }

  if(regForm){
    // Disable register button by default
    regButton.disabled = true;

    // Function to check if all fields are filled
    function validateRegisterForm() {
        if (
            regFirstNameInput.value.trim() !== "" &&
            regLastNameInput.value.trim() !== "" &&
            regEmailInput.value.trim() !== "" &&
            regPasswordInput.value.trim() !== ""
        ) {
            regButton.disabled = false;
        } else {
            regButton.disabled = true;
        }
    }

    // Listen for input changes
    regFirstNameInput.addEventListener("input", validateRegisterForm);
    regLastNameInput.addEventListener("input", validateRegisterForm);
    regEmailInput.addEventListener("input", validateRegisterForm);
    regPasswordInput.addEventListener("input", validateRegisterForm);

    regForm.addEventListener("submit", function (event) {
        event.preventDefault(); // Prevent default form submission

        const regFormData = new FormData(regForm);

        fetch('/account', {
            method: 'POST',
            body: regFormData,
            headers: {
                "X-Requested-With": "XMLHttpRequest" // Prevents full page reload
            }
        })
        .then(response => response.text())
        .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, "text/html");

            // Check for error messages inside Shopify's error class
            const errorMessage = doc.querySelector(".errors-text");

            if (errorMessage) {
                // Show error in the modal and prevent it from closing
                regErrorDiv.innerHTML = errorMessage.innerHTML;
                regErrorDiv.classList.remove("hidden");

                // Keep the modal open
                if (modal) {
                    modal.style.display = "flex"; // Adjust as per your modal styling
                }
            } else {
                // If no error, assume registration was successful
                window.location.reload();
            }
        })
        .catch(error => {
            console.error("Registration failed:", error);
            regErrorDiv.innerHTML = "An error occurred. Please try again.";
            regErrorDiv.classList.remove("hidden");

            // Ensure modal stays open
            if (modal) {
                modal.style.display = "flex";
            }
        });
    });
  }

  if(recoverForm){
    // Disable submit button initially
    recoverButton.disabled = true;
  
    // Validate email input
    function validateRecoverForm() {
      if (recoverEmailInput.value.trim()) {
        recoverButton.disabled = false;
      } else {
        recoverButton.disabled = true;
      }
    }

    // Listen for input changes
    recoverEmailInput.addEventListener("input", validateRecoverForm);
      // Handle form submission via AJAX
    recoverForm.addEventListener("submit", function (event) {
    event.preventDefault(); // Prevent default form submission

    const recoverFormData = new FormData(recoverForm);

    fetch("/account/recover", {
      method: "POST",
      body: recoverFormData,
      headers: {
        "X-Requested-With": "XMLHttpRequest", // Prevents full-page reload
      },
    })
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");

        // Check for error messages inside Shopify's error class
        const errorMessage = doc.querySelector(".errors-text");

        if (errorMessage) {
          // Show error inside the modal and prevent closing
          recoverErrorDiv.innerHTML = errorMessage.innerHTML;
          recoverErrorDiv.classList.remove("hidden");
        } else {
          // If no error, show success message
          recoverForm.innerHTML = `
            <div class="lightly-spaced-row-above">
              <p>Password reset email sent successfully! 📩</p>
              <span class="note">
                <a class="underline" href="#" id="back-to-login-recover">Back to Login</a>
              </span>
            </div>
          `;

          // Add event listener to back-to-login link
          // document.getElementById("back-to-login-recover").addEventListener("click", function (event) {
          //   event.preventDefault();
          //   document.getElementById("login-form").classList.remove("hidden");
          //   recoverForm.classList.add("hidden");
          // });
        }
      })
      .catch((error) => {
        console.error("Password recovery failed:", error);
        recoverErrorDiv.innerHTML = "An error occurred. Please try again.";
        recoverErrorDiv.classList.remove("hidden");
      });
  });
  }
 
});
